export const getSignupErrorMessage = (error) => {
  const code = String(error?.code || "");
  const message = String(error?.message || "");

  if (message.includes("GoogleAccountExists")) {
    return "An account with this email already exists via Google. Please sign in with Google.";
  }

  if (code === "UsernameExistsException") {
    return "An account with this email already exists. Please sign in.";
  }

  return message || "Signup failed. Please try again.";
};

export const getForgotPasswordErrorMessage = (error) => {
  const code = String(error?.code || "");
  const message = String(error?.message || "");

  if (
    code === "InvalidParameterException" ||
    code === "NotAuthorizedException"
  ) {
    return "This account uses Google Sign-In. Please sign in with Google instead.";
  }

  if (code === "UserNotFoundException") {
    return "No account found with this email or it may be registered via Google.";
  }

  return message || "Something went wrong.";
};

export const getLoginErrorMessage = (error) => {
  const code = String(error?.code || "");
  const message = String(error?.message || "");

  if (code === "NotAuthorizedException") {
    return 'Incorrect password. If you signed up with Google, please use "Sign in with Google".';
  }

  if (code === "UserNotFoundException") {
    return "No account found with this email or it may be registered via Google.";
  }

  return message || "Login failed. Please try again.";
};
